import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { WebRoutes } from "consts/enpoints/web";
import { Filters } from "consts/transactions";
import { useMatch, useParams } from "infrastructure/router";
import {
    KycSettingsCard,
    useKycSettingDetail,
    useKycSettingForm
} from "ui/organizms/PspKycSettings";
import Screen, { type ScreenProps } from "ui/layouts/Screen";

const ViewMode = () => {
    const {
        setting,
        isLoading,
        isDeleting,
        error,
        handleDelete
    } = useKycSettingDetail();

    return (
        <KycSettingsCard
            mode='view'
            setting={setting}
            isLoading={isLoading}
            isDeleting={isDeleting}
            error={error}
            onDelete={handleDelete}
        />
    );
};

const CreateMode = () => {
    const {
        formValues,
        fieldErrors,
        error,
        isSubmitting,
        onFieldChange,
        handleSubmit
    } = useKycSettingForm();

    return (
        <KycSettingsCard
            mode='create'
            formValues={formValues}
            fieldErrors={fieldErrors}
            error={error}
            isSubmitting={isSubmitting}
            onFieldChange={onFieldChange}
            onSave={handleSubmit}
        />
    );
};

const PSPKYCSettingsDetail = (props: ScreenProps) => {
    const params = useParams();
    const isCreate = Boolean(useMatch(WebRoutes.KYCSettings.PSPKYCSettings.New));
    const settingId = params[Filters.pspKycSettingId];

    const title = isCreate
        ? 'KYC Settings | Add PSP KYC Setting'
        : 'KYC Settings | PSP KYC Setting';

    return (
        <Screen
            {...props}
            title={title}
        >
            <Box sx={{ py: 2, px: 2 }}>
                {isCreate ? (
                    <CreateMode />
                ) : settingId ? (
                    <ViewMode />
                ) : (
                    <Box sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
                        <Typography variant='body1' color='text.secondary'>
                            Select a PSP KYC setting to view details.
                        </Typography>
                    </Box>
                )}
            </Box>
        </Screen>
    );
};

export default memo(PSPKYCSettingsDetail);
